import { LinkItem } from '@/domain/models/LinkItem';
import { DASHBOARD_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

// import { fetchLinkItems } from './mocks/linkItem';

interface Interface {
  fetch: () => Promise<LinkItem[]>;
}

export class LinkItemService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async fetch(): Promise<LinkItem[]> {
    return await this.restClient.get<LinkItem[]>(
      `${DASHBOARD_API_ORIGIN}/api/menus/sales-state-items` as const
    );
    // NOTE api schema のデータは件数が少ないため、件数を増やして検証をするときは restClientをコメントアウトして下記を使用してください。
    // return fetchLinkItems;
  }
}
